import { cn } from "@/core/utils";

/**
 * Card com altura fixa e scroll para uma lista de itens (ex.: colaboradores adicionados,
 * lista de remoção). Extraído do message-bubble para ser reusado pelo renderer do block
 * `expandable_list` (ST-3) além do caminho legado (response_added_list/response_expandable).
 */
export function AddedListCard({
  label,
  emails,
}: {
  label: string;
  emails: string[];
}) {
  return (
    <div className="overflow-hidden my-4 w-full" aria-label={label}>
      <div className="overflow-y-auto max-h-52 rounded-lg border border-border">
        <ul className="text-sm list-none list-disc list-inside text-darkgray-700">
          {emails.map((email, index) => (
            <li
              key={email}
              className={cn(
                "break-all border-b border-border p-2.5",
                index === emails.length - 1 ? "border-b-0" : "border-b",
              )}
            >
              {email}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
